var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3821_3878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 55.9996C43.4637 55.9996 55.9996 43.4637 55.9996 27.9998C55.9996 12.5359 43.4637 0 27.9998 0C12.5359 0 0 12.5359 0 27.9998C0 43.4637 12.5359 55.9996 27.9998 55.9996Z",
    fill: "#FEF6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9998 47.506C42.9998 41.7585 38.3405 37.0991 32.5929 37.0991H23.4069C17.6593 37.0991 13 41.7585 13 47.506V51.638C17.3369 54.396 22.4796 55.9999 27.9999 55.9999C33.5202 55.9999 38.6629 54.396 42.9998 51.638V47.506Z",
    fill: "#714FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 52.3427C33.1717 48.0086 36.8395 43.4837 38.03 38.6447C36.4462 37.6707 34.5885 37.0991 32.5929 37.0991H23.4069C21.4112 37.0991 19.5535 37.6707 17.9697 38.6447C18.9482 43.6634 22.7628 48.1392 27.9999 52.3427Z",
    fill: "#551EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4522 34.6833H16.5405L16.5605 34.6454C17.8495 32.2023 18.5405 29.2962 18.5405 26.3186V18.4111H37.4522V26.3186C37.4522 29.2962 38.1433 32.2023 39.4322 34.6454L39.4522 34.6833Z",
    fill: "#714FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3473 33.1135V38.1628C31.3473 40.176 29.8637 41.808 28.0335 41.808H27.9666C26.1364 41.808 24.6528 40.176 24.6528 38.1628V33.1135",
    fill: "#F5F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6528 35.3058C25.6587 35.7405 26.7585 35.9839 27.9133 35.9839H28.0868C29.2415 35.9839 30.3413 35.7405 31.3472 35.3058V33.9231H24.6528V35.3058Z",
    fill: "#F5F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5208 25.4365H19.4787C18.3284 25.4365 17.396 24.504 17.396 23.3538V23.3117C17.396 22.1615 18.3284 21.229 19.4787 21.229H19.5208C20.671 21.229 21.6035 22.1615 21.6035 23.3117V23.3538C21.6035 24.504 20.671 25.4365 19.5208 25.4365ZM36.5217 25.4365H36.4796C35.3294 25.4365 34.3969 24.504 34.3969 23.3538V23.3117C34.3969 22.1615 35.3294 21.229 36.4796 21.229H36.5217C37.6719 21.229 38.6044 22.1615 38.6044 23.3117V23.3538C38.6044 24.504 37.6719 25.4365 36.5217 25.4365Z",
    fill: "#F5F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0869 13.6653H27.9133C23.1667 13.6653 19.3188 17.7153 19.3188 22.7113V25.6371C19.3188 30.6331 23.1667 34.6831 27.9133 34.6831H28.0869C32.8335 34.6831 36.6814 30.6331 36.6814 25.6371V22.7113C36.6814 17.7153 32.8335 13.6653 28.0869 13.6653Z",
    fill: "#F5F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0909 7.91431H27.9018C22.7317 7.91431 18.5405 12.1055 18.5405 17.2756L18.5405 21.0966C19.7498 21.434 20.6672 20.9282 21.1679 19.219C21.6032 20.6171 20.4337 21.8078 20.4131 23.1693C24.8854 22.3053 30.5482 19.868 31.3172 14.6481C32.4461 18.1727 34.2949 20.6165 37.4522 21.0966L37.4522 17.2756C37.4522 12.1055 33.261 7.91431 28.0909 7.91431Z",
    fill: "#714FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 41.6798L23.1816 44.5223L21.6035 36.4609H25.0077L28.0002 41.6798Z",
    fill: "#C1B1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 41.6798L32.8186 44.5223L34.3966 36.4609H30.9925L28 41.6798Z",
    fill: "#C1B1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 43.6505C28.2948 43.6505 28.5338 43.4115 28.5338 43.1168C28.5338 42.822 28.2948 42.583 28.0001 42.583C27.7053 42.583 27.4663 42.822 27.4663 43.1168C27.4663 43.4115 27.7053 43.6505 28.0001 43.6505Z",
    fill: "#C1B1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 45.7884C28.2948 45.7884 28.5338 45.5495 28.5338 45.2547C28.5338 44.9599 28.2948 44.7209 28.0001 44.7209C27.7053 44.7209 27.4663 44.9599 27.4663 45.2547C27.4663 45.5495 27.7053 45.7884 28.0001 45.7884Z",
    fill: "#C1B1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 47.9256C28.2948 47.9256 28.5338 47.6867 28.5338 47.3919C28.5338 47.0971 28.2948 46.8582 28.0001 46.8582C27.7053 46.8582 27.4663 47.0971 27.4663 47.3919C27.4663 47.6867 27.7053 47.9256 28.0001 47.9256Z",
    fill: "#C1B1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3821_3878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/female-icon.30cea114c2daf2332e01a2c9639dcafc.svg";
export { ForwardRef as ReactComponent };